import { Flex, Text } from '@chakra-ui/react';
import { FaRegCircleUser } from 'react-icons/fa6';
import { useAuth } from '../../contexts/AuthContext';
import { HelivanColor } from './HelivanColor';

export const HelivanAvatar = ({ clickable }: { clickable?: boolean }) => {
  const { backendUser } = useAuth();
  const [firstName, lastName] = (backendUser?.fullName ?? '').split(' ');

  return (
    <Flex
      width="32px"
      height="32px"
      flexGrow={0}
      alignItems="center"
      justifyContent="center"
      bg="#D8E8FF"
      p="6px"
      borderRadius="full"
      _hover={
        clickable
          ? {
              cursor: 'pointer',
              bg: '#C5DCFA',
            }
          : undefined
      }
      transition="0.2s"
    >
      {firstName && lastName ? (
        <Text
          fontWeight={500}
          fontSize="12px"
          color={HelivanColor.text.helivanBlue}
        >{`${firstName.slice(0, 1)}${lastName.slice(0, 1)}`}</Text>
      ) : (
        <FaRegCircleUser color={HelivanColor.text.helivanBlue} size={16} />
      )}
    </Flex>
  );
};
